import React from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Checkbox, Form, Input, Select } from 'antd'
import { useAppSelector } from '../../../hooks/redux'
import { swalAttentionLeave } from '../../../functions/swalOptions'
import swalConfig from '../../../app/texts/swalTexts'
import { reduceLinks, type StateLink } from '../../../functions/agent/advertises/reduceLinks'
import { normalizeLinksArray, splitAdvertiseLinks } from '../../../functions/agent/advertises/portalLinks'

export default function AgentAdvertiseCreateLinks({ form, objectID }: any): JSX.Element {
    const advertises = useAppSelector(state => state.advertises.advertises)
    const currentAdvertise = advertises?.filter((adv) => adv.id === Number(objectID))?.[0]
    const { trakheesi } = splitAdvertiseLinks(currentAdvertise?.attributes?.Links)
    const currentStatus = currentAdvertise?.attributes?.Statuses?.[currentAdvertise?.attributes?.Statuses?.length - 1]
    const isPortalLinksFlow = currentStatus === 'Links approved' || currentStatus === 'Advertisement started'

    const mappedLinks: StateLink[] = isPortalLinksFlow
        ? reduceLinks(currentAdvertise)
        : normalizeLinksArray(currentAdvertise?.attributes?.Links)
            .filter((link) => (typeof link?.Trakheesi_id === 'string' && link.Trakheesi_id.trim().length > 0) && (link?.Link == null || String(link.Link).trim() === ''))
            .map((link: any, index: number) => ({
                Trakheesi_id: link?.Trakheesi_id ?? '',
                Status: link?.Status ?? 'In-process',
                __sourceIndex: index
            }))

    const trakheesiLabel = trakheesi
        .map((item) => item?.Trakheesi_id)
        .filter((value) => typeof value === 'string' && value.length > 0)
        .join(', ')

    const updateStatusToInProcess = (name: number): void => {
        const currentLinks = form.getFieldValue('links')
        currentLinks[name] = {
            ...currentLinks[name],
            Status: 'In-process'
        }
        form.setFieldsValue({ links: currentLinks })
    }

    return (
        <div className='p-0'>
            <Form
                form={form}
                name="advertise"
                style={{ maxWidth: 600 }}
                autoComplete="off"
                initialValues={{
                    links: mappedLinks
                }}
            >
                {isPortalLinksFlow && trakheesiLabel.length > 0 && (
                    <div className='mb-5 p-3 rounded border border-gray-300 bg-light-info'>
                        <div className='fs-7 fw-bold text-uppercase text-gray-800 mb-1'>Trakheesi ID</div>
                        <div className='fs-6 text-gray-900'>{trakheesiLabel}</div>
                    </div>
                )}
                <Form.List name="links">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }, index) => {
                                const currentLinks = form.getFieldValue('links')
                                const isExistingField = currentLinks?.[name]
                                const isLastItem = index === currentLinks.length - 1
                                const isDisabled = isExistingField?.Disabled === true
                                return (
                                    <div key={key}>
                                        <div className='d-flex justify-content-between p-0'>
                                            <span className={`bullet bullet-vertical d-flex align-items-center h-auto bg-${isExistingField && isExistingField?.Status === 'Approved' ? 'success' : isExistingField && isExistingField?.Status === 'Rejected' ? 'danger' : 'warning'}`}></span>
                                            <div className='w-100 px-1 mx-1'>
                                                <div className='m-0 p-0 d-flex justify-content-between align-items-center'>
                                                    {(isExistingField && isExistingField?.Status === 'Approved')
                                                        ? (
                                                            <span className='mb-2'>
                                                                <span className="badge badge-success">Approved</span>
                                                            </span>
                                                            )
                                                        : (isExistingField && isExistingField?.Status !== 'In-process')
                                                                ? (
                                                                    <span className='pt-1'>
                                                                        <span className="badge badge-danger">Rejected</span>
                                                                    </span>
                                                                    )
                                                                : (
                                                                    <span className='mb-2'>
                                                                        <span className="badge badge-warning">In-process</span>
                                                                    </span>
                                                                    )}

                                                    {!isPortalLinksFlow && isExistingField?.Status !== 'Approved' && (
                                                        <i className="fs-4x ki-duotone ki-cross-square " onClick={async () => {
                                                            await swalAttentionLeave(swalConfig.attentionLeave.messageForClearRowLinkAdvertise).then(async (result: any) => {
                                                                if (result.isConfirmed) {
                                                                    remove(name)
                                                                }
                                                            })
                                                        }}>
                                                            <span className="path1 text-dark" style={{ filter: 'brightness(0)' }}></span>
                                                            <span className="path2 text-white" style={{ filter: 'brightness(1)' }}></span>
                                                        </i>
                                                    )}
                                                </div>

                                                <div className='m-0 p-0'>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'Status']}
                                                        initialValue={'In-process'}
                                                        className='h-1px m-0 p-0'
                                                    >
                                                        <Input hidden value="In-process" />
                                                    </Form.Item>
                                                </div>

                                                {!isPortalLinksFlow && (
                                                    <div className='m-0 pb-2'>
                                                        <span className="text-gray-800 fw-semi-bold d-block mb-1 fs-7 required form-label fw-bold text-dark text-uppercase">Trakheesi</span>
                                                        <Form.Item
                                                            {...restField}
                                                            name={[name, 'Trakheesi_id']}
                                                            rules={[
                                                                {
                                                                    required: !isExistingField?.Status || isExistingField?.Status !== 'Approved',
                                                                    message: 'Missing Trakheesi ID'
                                                                }
                                                            ]}
                                                            className='my-1 p-0 mb-1'
                                                        >
                                                            <Input size="middle" className='form-control form-control-sm m-0 p-2'
                                                                disabled={isExistingField?.Status === 'Approved'}
                                                                placeholder="253479128002"
                                                                onChange={(e) => {
                                                                    const currentRows = form.getFieldValue('links')
                                                                    currentRows[name] = {
                                                                        ...currentRows[name],
                                                                        Trakheesi_id: e.target.value,
                                                                        Status: 'In-process'
                                                                    }
                                                                    form.setFieldsValue({ links: currentRows })
                                                                    updateStatusToInProcess(name)
                                                                }}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                )}

                                                {isPortalLinksFlow && (
                                                    <>
                                                        <div className='m-0 p-0'>
                                                            <span className="text-gray-800 fw-semi-bold d-block mb-1 fs-7 required form-label fw-bold text-dark text-uppercase">Portal name</span>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Title']}
                                                                rules={[
                                                                    {
                                                                        required: !isDisabled,
                                                                        message: 'Missing portal name'
                                                                    }
                                                                ]}
                                                                className='my-1 p-0'
                                                            >
                                                                <Input size="small" className='form-control form-control-sm m-0 p-2'
                                                                    disabled={isExistingField?.Status === 'Approved'}
                                                                    placeholder='Dubizzle, Bayut, Property Finder...'
                                                                    onChange={(e) => {
                                                                        const currentRows = form.getFieldValue('links')
                                                                        currentRows[name] = {
                                                                            ...currentRows[name],
                                                                            Title: e.target.value,
                                                                            Status: 'In-process'
                                                                        }
                                                                        form.setFieldsValue({ links: currentRows })
                                                                        updateStatusToInProcess(name)
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>

                                                        <div className='m-0 p-0'>
                                                            <span className="text-gray-800 fw-semi-bold d-block mb-1 fs-7 required form-label fw-bold text-dark text-uppercase">Portal link</span>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Link']}
                                                                rules={[
                                                                    {
                                                                        required: !isDisabled,
                                                                        message: 'Missing portal link'
                                                                    },
                                                                    {
                                                                        validator: async (_, value) => {
                                                                            if (isDisabled || value == null || value === '') {
                                                                                return
                                                                            }
                                                                            if (!/^https?:\/\//i.test(String(value))) {
                                                                                throw new Error('Portal link must start with http:// or https://')
                                                                            }
                                                                        }
                                                                    }
                                                                ]}
                                                                className='my-1 p-0'
                                                            >
                                                                <Input className='form-control form-control-sm m-0 p-2'
                                                                    disabled={isExistingField?.Status === 'Approved'}
                                                                    placeholder='https://...'
                                                                    onChange={(e) => {
                                                                        const currentRows = form.getFieldValue('links')
                                                                        currentRows[name] = {
                                                                            ...currentRows[name],
                                                                            Link: e.target.value,
                                                                            Status: 'In-process'
                                                                        }
                                                                        form.setFieldsValue({ links: currentRows })
                                                                        updateStatusToInProcess(name)
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>

                                                        <div className='m-0 pb-2'>
                                                            <span className="text-gray-800 fw-semi-bold d-block mb-1 fs-7 form-label fw-bold text-dark text-uppercase">Comment</span>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Comment']}
                                                                className='my-1 p-0 mb-1'
                                                            >
                                                                <Input.TextArea
                                                                    rows={2}
                                                                    className='form-control form-control-sm m-0 p-2'
                                                                    disabled={isExistingField?.Status === 'Approved'}
                                                                    placeholder='Optional comment for admin review'
                                                                    onChange={(e) => {
                                                                        const currentRows = form.getFieldValue('links')
                                                                        currentRows[name] = {
                                                                            ...currentRows[name],
                                                                            Comment: e.target.value,
                                                                            Status: 'In-process'
                                                                        }
                                                                        form.setFieldsValue({ links: currentRows })
                                                                        updateStatusToInProcess(name)
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>

                                                        <div className='m-0 pb-2'>
                                                            <span className="text-gray-800 fw-semi-bold d-block mb-1 fs-7 form-label fw-bold text-dark text-uppercase">Disabled</span>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Disabled']}
                                                                valuePropName='checked'
                                                                initialValue={false}
                                                                className='my-1 p-0 mb-1'
                                                            >
                                                                <Checkbox
                                                                    disabled={isExistingField?.Status === 'Approved'}
                                                                    onChange={(e) => {
                                                                        const currentRows = form.getFieldValue('links')
                                                                        currentRows[name] = {
                                                                            ...currentRows[name],
                                                                            Disabled: e.target.checked,
                                                                            Status: 'In-process'
                                                                        }
                                                                        form.setFieldsValue({ links: currentRows })
                                                                        updateStatusToInProcess(name)
                                                                    }}
                                                                >
                                                                    Disable this portal link (kept for history)
                                                                </Checkbox>
                                                            </Form.Item>
                                                        </div>

                                                        <div className='m-0 pb-2'>
                                                            <span className="text-gray-800 fw-semi-bold d-block mb-1 fs-7 form-label fw-bold text-dark text-uppercase">Status</span>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Status']}
                                                                className='my-1 p-0 mb-1'
                                                            >
                                                                <Select
                                                                    disabled={isExistingField?.Status === 'Approved'}
                                                                    options={[
                                                                        { label: 'In-process', value: 'In-process' },
                                                                        { label: 'Rejected', value: 'Rejected' },
                                                                        { label: 'Approved', value: 'Approved' }
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {!isLastItem && <div className="separator separator-dashed border-gray-500 my-3"></div>}
                                    </div>
                                )
                            })}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    className="btn btn-bso mt-2"
                                    style={{ padding: '2px' }}
                                    onClick={() => {
                                        add(isPortalLinksFlow
                                            ? {
                                                Title: '',
                                                Link: '',
                                                Comment: '',
                                                Disabled: false,
                                                Status: 'In-process'
                                            }
                                            : {
                                                Trakheesi_id: '',
                                                Status: 'In-process'
                                            })
                                    }}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    {isPortalLinksFlow ? 'Add portal link' : 'Add Trakheesi ID'}
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form>

        </div>

    )
}
